var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 1C14.1046 1 15 1.89543 15 3V9H12C10.8954 9 10 9.89543 10 11V14H3C1.89543 14 1 13.1046 1 12V3C1 1.89543 1.89543 1 3 1H13ZM11 14V11C11 10.4477 11.4477 10 12 10H15L11 14ZM4 9H8V8H4V9ZM4 7H10V6H4V7ZM4 5H12V4H4V5Z",
    fill: "#646A82"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/Message.d742a11ed4668897e3271b7afec54222.svg";
export { ForwardRef as ReactComponent };